import React from 'react';
import { observer, inject } from 'mobx-react';
import PageTitle from '../../components/PageTitle/PageTitle';
import Loader from '../../components/Loader/LoaderView';
import FormInputLabel from '../../components/FormInputLabelView';
import { Link } from 'react-router-dom';
import {
  Grid,
  withStyles,
  TextField,
  Button,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Checkbox,
  IconButton,
} from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import { withTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { clearLocalStorage } from '../../utils/common';

class AssignModules extends React.Component {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      groupName: '',
      loading: false,
      subGroupsList: [],
      selectSubGroups: [],
    };
  }

  async componentDidMount() {
    const { offset, limit, search, sort, order, tenantIds } = this.props.group.toJS();
    await this.props.group.getGroupCMSList(offset, limit, search, sort, order, tenantIds);
    this.initData();
  }

  async initData() {
    const groupPath = this.props.location.pathname.replace('/app/groups/', '');
    const groupId = Number(groupPath.replace('/assign', ''));

    const { groupscms } = this.props.group.toJS();
    const showGroupData = groupscms.data.find((item) => item.id === groupId);
    if (showGroupData) {
      await this.props.subGroup.getBasicSubgroupInfoByTenantId(showGroupData.tenant.id);
      this.setState({ groupName: showGroupData.name });
    }

    await this.props.subGroup.getSubGroupByGroupID(groupId);
    const { ListSubGroups, subGroupsInfo } = this.props.subGroup.toJS();
    const List = (subGroupsInfo || []).map((val) => {
      return {
        id: val.id,
        label: val.name,
      };
    });
    // const List = (subGroups.data || [])
    //   .filter(val => (val.id && (!val.groupId || val.groupId === groupId)))
    //   .map(val => {
    //     return {
    //       id: val.id,
    //       label: val.name
    //     };
    //   });

    this.setState({ subGroupsList: List });

    let mapSubGroup = (ListSubGroups || []).map((val) => {
      const data = {
        id: '',
        label: '',
      };
      if (val.id) {
        data.id = val.id;
        data.label = val.name;
      }
      return data;
    });

    this.setState({ selectSubGroups: mapSubGroup });
  }

  goBack() {
    this.props.history.goBack();
  }

  handleChange(selectSubGroups) {
    this.setState({ selectSubGroups });
  }

  handleToggle(val) {
    let selectSubGroups = this.state.selectSubGroups;
    const checkSelected = selectSubGroups.find((data) => data.id === val.id);

    if (checkSelected) {
      selectSubGroups = selectSubGroups.filter((data) => data.id !== val.id);
    } else {
      selectSubGroups.push(val);
    }
    this.setState({ selectSubGroups });
  }

  handleDelete(val) {
    const selectSubGroups = this.state.selectSubGroups.filter((data) => data.id !== val.id);
    this.setState({ selectSubGroups });
  }

  handleSaveModules = async () => {
    const { t } = this.props;
    const groupPath = this.props.location.pathname.replace('/app/groups/', '');
    const groupId = Number(groupPath.replace('/assign', ''));
    try {
      const result = await this.props.subGroup.saveModules(this.state.selectSubGroups, groupId);
      if (result.statusCode === 200) {
        Swal.fire({ html: `<h4>${t('assign_success')}`, type: 'success' }).then(async (resultSuccess) => {
          if (resultSuccess.value) {
            await this.props.group.getGroupCMSList();
            this.props.history.push('../../groups');
          }
        });
      } else {
        Swal.fire({ html: `<h4>${t('failed_to_assign')}`, type: 'error' });
      }
    } catch (e) {
      if (e.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      } else {
        Swal.fire({ html: `<h4>${t('failed_to_assign')}`, type: 'error' });
      }
    }
  };

  render() {
    const { loading } = this.props.group.toJS();
    const { classes, t } = this.props;
    const { subGroupsList, selectSubGroups, groupName } = this.state;

    return (
      <React.Fragment>
        <Loader loading={loading} />
        <Paper className={classes.paper}>
          <PageTitle title={t('assign_module')} />
          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('group_name')} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField id='name' name='name' fullWidth value={groupName} variant='outlined' margin='dense' disabled />
            </Grid>
          </Grid>
          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={6} sm={6}>
              <FormInputLabel label={t('list_all_modules')} />
            </Grid>
            <Grid item xs={6} sm={6}>
              <FormInputLabel label={t('modules_in_group')} />
            </Grid>
          </Grid>
          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={6}>
              <List className={subGroupsList.length > 0 ? classes.muitiSelect : classes.muitiSelectNoBorder}>
                {subGroupsList.map((val) => {
                  return (
                    <ListItem key={val.id} role={undefined} dense button onClick={() => this.handleToggle(val)}>
                      <ListItemIcon style={{ marginRight: '0px' }}>
                        <Checkbox
                          style={{ padding: '0px' }}
                          color='primary'
                          edge='start'
                          checked={selectSubGroups.find((data) => data.id === val.id) ? true : false}
                          tabIndex={-1}
                          disableRipple
                          inputProps={{ 'aria-labelledby': `checkbox-list-label-${val.id}` }}
                        />
                      </ListItemIcon>
                      <ListItemText
                        className={classes.labelCheckBox}
                        id={`checkbox-list-label-${val.id}`}
                        primary={`${val.label}`}
                      />
                    </ListItem>
                  );
                })}
              </List>
            </Grid>
            <Grid item xs={6}>
              <List className={selectSubGroups.length > 0 ? classes.muitiSelect : classes.muitiSelectNoBorder}>
                {selectSubGroups.map((val) => {
                  return (
                    <ListItem key={val.id} role={undefined} dense button onClick={() => this.handleDelete(val)}>
                      <ListItemIcon style={{ marginRight: '0px' }}>
                        <IconButton style={{ padding: '0px' }} edge='end' aria-label='delete'>
                          <ClearIcon />
                        </IconButton>
                      </ListItemIcon>
                      <ListItemText
                        className={classes.labelCheckBox}
                        id={`select-list-label-${val.id}`}
                        primary={`${val.label}`}
                      />
                    </ListItem>
                  );
                })}
              </List>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <div className={classes.buttons}>
              <Link to='/app/groups'>
                <Button className={classes.button}>{t('back')}</Button>
              </Link>
              <Button
                variant='contained'
                color='primary'
                onClick={() => this.handleSaveModules()}
                className={classes.button}
              >
                {t('save')}
              </Button>
            </div>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }
}

const styles = (theme) => ({
  labelCheckBox: {
    paddingLeft: '5px',
    [theme.breakpoints.down('sm')]: {
      overflow: 'hidden',
      padding: '0',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitLineClamp: '1',
      WebkitBoxOrient: 'vertical',
    },
  },
  paper: {
    padding: '24px',
    margin: '30px',
  },
  wrapContain: {
    padding: '10px 20px',
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginLeft: '5px',
  },
  muitiSelect: {
    marginBottom: '35px',
    borderRadius: '5px',
    borderStyle: 'solid',
    borderColor: 'gray',
    borderWidth: '1px',
  },
  boxSelect: {},
  muitiSelectNoBorder: {
    marginTop: '35px',
    marginBottom: '35px',
  },
});

export const page = inject('subGroup', 'group')(observer(AssignModules));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
